class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    // Check for redirect conditions before showing predictive search
    if (this.checkStaticPagesAndRedirect(searchTerm)) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    console.log("testt", routes.predictive_search_url);
    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[options][fields]=variants.sku,variants.barcode,title`)
      .then((response) => {
        if (!response.ok) {
          this.close();
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
        this.initTabSwitcher();
        initializeGreenBadgeCarousels(this.predictiveSearchResults); // Optional if you're using badge carousels
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  initTabSwitcher() {
    const tabButtons = this.predictiveSearchResults.querySelectorAll('.predictive-search-tab-button');
    const tabContents = this.predictiveSearchResults.querySelectorAll('.predictive-search-tab-content');

    tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const targetTab = button.getAttribute('data-tab');
        tabButtons.forEach((btn) => btn.classList.remove('active'));
        button.classList.add('active');
        tabContents.forEach((content) => {
          content.hidden = content.getAttribute('data-tab') !== targetTab;
        });
      });
    });
  }

  checkStaticPagesAndRedirect(searchTerm) {
    const lowerCaseSearchTerm = searchTerm?.toLocaleLowerCase();
    if (!lowerCaseSearchTerm) return false;

    const staticPagesObject = {
      "/pages/iade-ve-degisim": ["iade", "i̇ade"],
      "/pages/iletisim": ["iletisim", "iletisim sayfası", "i̇letisim sayfası", "i̇letisim"],
      "/pages/magazalar": ["mağaza", "mağazalarımız", "mağazalar", "mağaza sayfası", "magaza"],
      "/account?view=orders": ["sipariş", "siparişlerim", "siparişim", "sipariş sorgulama"],
    };

    const isLoggedIn = this.dataset.loggedin === "true";

    for (const [url, keywords] of Object.entries(staticPagesObject)) {
      if (keywords.includes(lowerCaseSearchTerm)) {
        if (url.includes("/account") && !isLoggedIn) {
          window.location.href = window.hpI18n.url("/pages/siparis-takip");
        } else {
          window.location.href = window.hpI18n.url(url);
        }
        return true;
      }
    }

    return false;
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
